<mat-form-field class="full-width">
  <mat-label>{{ placeholder | capitaliz }}</mat-label>
  <input data-cy="generic-uniselect__field-input" #inputField matInput [matAutocomplete]="auto" [matChipInputFor]="chipGrid" 
         [formControl]="searchControl" [disabled]="disabled" [class]="uniqueId"/>
  <mat-chip-grid #chipGrid aria-label="Enter item">
    <mat-chip-row *ngFor="let value of selectedValue" (removed)="remove()" 
                 [aria-description]="'press enter to edit ' + value.name">
      <span class="disp-flex">
        <p *ngIf="uniqueId!=='context-type'">{{value.name | trunc:20}}</p>
        <p *ngIf="uniqueId==='context-type'">{{ 'contexts.context_type.'+value.name | transloco | capitaliz }}</p>
        <mat-icon matChipRemove>cancel</mat-icon>
      </span>
    </mat-chip-row>
  </mat-chip-grid>
  
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="updateValue($event)" autoActiveFirstOption>
    <mat-option *ngFor="let item of filteredItems; let index = index;" [value]="item" 
               [class]="uniqueId + '-list-item-' + (index + 1)" class="pad-y-1 disp-flex">
        <mat-icon class="radio-button">
          {{ (selectedValue.length && selectedValue[0]?.id === item.id) ? 'radio_button_checked' : 'radio_button_unchecked' }}
        </mat-icon>
        <span *ngIf="uniqueId!=='context-type'">{{item.name}}</span>
        <span *ngIf="uniqueId==='context-type'">{{ 'contexts.context_type.'+item.name | transloco | capitaliz }}</span>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>